var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 606.1 154.2",
    style: {
      enableBackground: "new 0 0 606.1 154.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8ECBB4;}\n\t.st1{fill:#B48983;}\n\t.st2{fill:#65755D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,71l24.6-24.6l-33-33c-3.3-3.3-8.8-3.3-12.1,0L29.2,29.7c-26.1,26.1-26.1,68.5,0,94.7l16.3,16.3 c3.3,3.3,8.8,3.3,12.1,0l33-33L66,83.1C62.6,79.8,62.6,74.3,66,71L66,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,29.7l-16.3-16.3c-3.3-3.3-8.8-3.3-12.1,0l-33,33L115.2,71c3.3,3.3,3.3,8.8,0,12.1l-24.6,24.6l33,33 c3.3,3.3,8.8,3.3,12.1,0l16.3-16.3C178.1,98.3,178.1,55.9,152,29.7L152,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66,83.1l24.6,24.6l24.6-24.6c3.3-3.3,3.3-8.8,0-12.1L90.6,46.4L66,71C62.6,74.4,62.6,79.8,66,83.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M480.3,110.5l-4-4l-4,4c-0.5,0.5-0.5,1.4,0,2l4,4l4-4C480.9,111.9,480.9,111,480.3,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.2,97.3c0,9.4-5.7,14.1-17.1,14.1S217,106.7,217,97.3v-8.6h7.1v9c0,2.4,0.8,4.3,2.5,5.7 c1.7,1.4,4.2,2,7.5,2s5.8-0.7,7.5-2c1.7-1.4,2.5-3.2,2.5-5.5s-0.2-4.2-0.8-5.6s-1.5-2.9-3.1-4.4l-17.8-17.4 c-2.1-2.1-3.5-4.1-4.3-6.1c-0.8-2-1.2-4.5-1.2-7.5c0-4.5,1.4-8,4.2-10.5c2.8-2.5,7-3.7,12.7-3.7c10.9,0,16.3,4.7,16.3,14.1v8.6 h-7.1v-9c0-2.4-0.8-4.3-2.4-5.7c-1.6-1.4-4-2-7.1-2s-5.5,0.7-7.1,2s-2.4,3.2-2.4,5.6s0.2,4.2,0.7,5.6s1.5,2.8,3.1,4.2L246,83.5 c2,2.2,3.3,4.2,4,6.2C250.8,91.7,251.2,94.2,251.2,97.3L251.2,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M381.2,56.9v40.4c0,4.5-1.4,8-4.3,10.5s-7.1,3.7-12.8,3.7s-10-1.2-12.9-3.7c-2.9-2.5-4.4-5.9-4.4-10.5V56.9 c0-4.5,1.4-8,4.3-10.5c2.9-2.5,7.1-3.7,12.8-3.7s10,1.2,12.9,3.7C379.8,48.9,381.2,52.3,381.2,56.9z M374.1,97.3V56.9 c0-5.4-3.4-8.1-10.1-8.1s-10.1,2.7-10.1,8.1v40.4c0,5.4,3.4,8.1,10.1,8.1S374.1,102.7,374.1,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M420.7,97.3V42.7h7.1v54.6c0,2.6,0.6,4.5,1.7,6c1.1,1.4,3.2,2.1,6.1,2.1s5.7-1.1,8.2-3.4 c2.5-2.3,3.7-4.5,3.7-6.7V42.7h7.1v67.2h-3l-2.6-6.5c-1.5,2.4-3.4,4.4-5.7,5.8c-2.3,1.5-4.9,2.2-7.6,2.2 C425.6,111.4,420.7,106.7,420.7,97.3L420.7,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M596.5,56.9v54.5h-7.1V56.9c0-2.6-0.6-4.6-1.7-6c-1.1-1.4-3.2-2.1-6.1-2.1s-5.7,1.1-8.2,3.4 c-2.5,2.3-3.7,4.5-3.7,6.7v52.5h-7.1v-91h6.9V49c1.7-2,2.2-2.6,4.5-4.1c2.3-1.4,4.9-2.2,7.6-2.2C591.5,42.8,596.5,47.5,596.5,56.9 L596.5,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M520.8,97.3v-5.6h7.1v5.6c0,4.5-1.4,8-4.1,10.5s-6.9,3.7-12.4,3.7s-9.7-1.2-12.5-3.7s-4.2-5.9-4.2-10.5V56.8 c0-4.5,1.4-8,4.1-10.5s6.9-3.7,12.4-3.7s9.7,1.2,12.5,3.7s4.2,5.9,4.2,10.5v9.6h-7.1v-9.6c0-5.4-3.2-8.1-9.6-8.1s-9.6,2.7-9.6,8.1 v40.5c0,5.4,3.2,8.1,9.6,8.1S520.8,102.7,520.8,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.4,48.8v-6.1h-14.1V20.4h-7.1v22.3h-7.1v6.1h7.1v48.5c0,9.4,5,14.1,14.9,14.1c0.7,0,1.4,0,2.1-0.1v-6.1 c-0.7,0.1-1.4,0.2-2.1,0.2c-3,0-5-0.7-6.1-2.1c-1.1-1.4-1.7-3.4-1.7-6V48.8L316.4,48.8L316.4,48.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.98900bca521b43c9fa4b8886c4b2d718.svg";
export { ForwardRef as ReactComponent };